import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function CompressIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M5 8L5 11L2 11L2 13L5 13L5 16L9 12L5 8ZM20 16L20 13L23 13L23 11L20 11L20 8L16 12L20 16ZM15 4L13 4L13 20L15 20L15 4Z" fill="currentColor"/>
      <path d="M12 4L12 20L10 20L10 4L12 4Z" fill="currentColor"/>
    </SvgIcon>
  );
}
